import type { SubjectFieldDefinitionPayload } from '@Application/SubjectTypes/Actions/subjectTypesFetched';
import SubjectFieldOptionView from '@UI/Store/SubjectTypes/Views/SubjectFieldOptionView';

const FILTERABLE_NATURES: readonly string[] = ['choice', 'multiple_choice', 'boolean'];
const SORTABLE_NATURES: readonly string[] = ['text', 'date', 'number', 'boolean'];
const CARD_NATURES: readonly string[] = ['text', 'date', 'number', 'boolean', 'choice'];

/**
 * One active field of a dossier type. An unknown nature is kept as received: it is simply neither
 * filterable, sortable nor shown on the card.
 */
class SubjectFieldDefinitionView {
	readonly key: string;
	readonly label: string;
	readonly nature: string;
	readonly natureLabel: string;
	readonly options: readonly SubjectFieldOptionView[];
	readonly required: boolean;

	constructor(payload: SubjectFieldDefinitionPayload) {
		this.key = payload.key;
		this.label = payload.label;
		this.nature = payload.nature.value;
		this.natureLabel = payload.nature.label;
		this.options = payload.options.map((option) => new SubjectFieldOptionView(option));
		this.required = payload.required;

		Object.freeze(this);
	}

	get isFilterable(): boolean {
		return FILTERABLE_NATURES.includes(this.nature);
	}

	get isSortable(): boolean {
		return SORTABLE_NATURES.includes(this.nature);
	}

	get isShownOnCard(): boolean {
		return CARD_NATURES.includes(this.nature);
	}
}

export default SubjectFieldDefinitionView;
